import { parseISO } from 'date-fns';

export const convertUtcDateToLocaleTimezone = (date: Date | string): Date => {
    const myDt = typeof date === 'string' ? parseISO(date) : date;
    return new Date(myDt.getTime() + myDt.getTimezoneOffset() * 60 * 1000);
};

export const convertLocaleTimezoneDateToUtc = (date: Date | string): Date => {
    const myDt = typeof date === 'string' ? parseISO(date) : date;
    return new Date(myDt.getTime() - myDt.getTimezoneOffset() * 60 * 1000);
};

export const simpleDateToIsoString = (date: Date): string => {
    const MM = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
    const DD = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
    return `${date.getFullYear()}-${MM}-${DD}`;
};
